import { type FC } from 'react';

import {
  HEADER_TYPE_MODALS,
  HeaderModalVariant
} from '@/components/AdvertisePayments/components/Header/Header.types';
import { HeaderMainModal } from '@/components/AdvertisePayments/components/Header/HeaderMain';
import { HeaderSecondaryModal } from '@/components/AdvertisePayments/components/Header/HeaderSecondary';

export const HeaderModal: FC<HeaderModalVariant> = (
  headerVariant: HeaderModalVariant
) => {
  switch (headerVariant.type) {
    case HEADER_TYPE_MODALS.MAIN:
      return (
        <HeaderMainModal
          onModalClose={headerVariant.onModalClose}
          contentTitle={headerVariant.contentTitle}
        />
      );

    case HEADER_TYPE_MODALS.SECONDARY:
      return (
        <HeaderSecondaryModal
          onBack={headerVariant.onBack}
          contentTitle={headerVariant.contentTitle}
        />
      );
    default:
      return null;
  }
};
